<template>
  <va-create-layout>
    <general-form :title="title" :item="item"></general-form>
  </va-create-layout>
</template>

<script>
export default {
  props: ["title", "item"],
};
</script>
